export default () => ({
  centerPanel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});



// WEBPACK FOOTER //
// ./src/components/Panels/CenterPanel.styles.js